export const KEY_CACHE_PROCESSES = 'processes';
export const keyCacheInterventionType = 'saved-intervention-types';
export const keyCacheBusinessType = 'saved-business-types';
